// st-faq block: expand/collapse toggle with slide animation. Delegated so
// it works for blocks added dynamically in the editor preview as well.
// Guarded: ACF enqueues this file once per block type on the page
// (block-faq, block-cta, ...), so it may execute multiple times.
if ( ! window.stBlocksAcfBound ) {
  window.stBlocksAcfBound = true;

  document.addEventListener( 'click', function( e ) {

    var toggle = e.target.closest( '.st-faq__toggle' );
    if ( ! toggle ) return;

    var item = toggle.closest( '.st-faq__item' );
    var answer = item.querySelector( '.st-faq__answer' );
    var open = item.classList.toggle( 'active' );

    toggle.setAttribute( 'aria-expanded', open );

    if ( window.jQuery ) {
      window.jQuery( answer ).stop( true )[ open ? 'slideDown' : 'slideUp' ]();
    } else {
      answer.style.display = open ? '' : 'none';
    }

  } );
}
